import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { ITemporaryAnnouncement, ITemporaryAnnouncementSpot } from "../interfaces/temporaryAnnouncements";
import { getActiveTemporaryAnnouncements } from "../services/announcements";
import { AppState } from "../store";


type Props = {
  spot: ITemporaryAnnouncementSpot;
  onSuccess?: (announcement: ITemporaryAnnouncement) => void;
}

export const TEMPORARY_ANNOUNCEMENTS_QUERY_KEY = 'temporaryAnnouncements';

export const useTemporaryAnnouncements = ({ spot, onSuccess }: Props) => {
  const token = useSelector((state: AppState) => state.user.token);

  return useQuery({
    queryKey: [TEMPORARY_ANNOUNCEMENTS_QUERY_KEY, spot, token],
    queryFn: () => getActiveTemporaryAnnouncements({ spot }),
    onSuccess,
    enabled: !!token,
    retry: false,
  })
}

